import { LitElement, html, css } from 'lit'
import '../../../bui/elements/text'

class TextHeader extends LitElement{

    static properties = {
        href: {type: String}
    }

    static styles = css`
        :host {
            display: contents;
            font-family: var(--font-header);
        }

        :host > * {
            margin-top: 0;
            margin-bottom: 0;
        }

        h4 { font-weight: normal;}

        a {
            text-decoration: none;
            color: inherit;
        }

        @media (hover: hover) {
            a {
                color: #000;
                position: relative;
                text-decoration: none;
            }

            a::before {
                background: var(--orange);
                content: "";
                inset: 0;
                position: absolute;
                transform: scaleX(0);
                transform-origin: right;
                transition: transform 0.15s ease-in-out;
                z-index: -1;
                clip-path: polygon(2% 0, 100% 0, 98% 100%, 0 100%);
                height: .5em;
                top: auto;
            }

            a:hover::before {
                transform: scaleX(1);
                transform-origin: left;
            }
        }

        :host([color="blue"]) { color: var(--blue);}
        :host([color="green"]) { color: var(--green);}
        :host([color="orange"]) { color: var(--orange);}

        ::slotted(*) {
            font-size: inherit !important;
            font-weight: inherit !important;
            font-family: inherit !important;
        }
    `

    render(){return html`
        ${this.href?html`<a href=${this.href} target="_self">
            <slot></slot>
        </a>`:html`
            <slot></slot>
        `}
    `}

}

customElements.define('k-h1', class extends TextHeader{ render(){return html`<h1>${super.render()}</h1>`}})
customElements.define('k-h2', class extends TextHeader{ render(){return html`<h2>${super.render()}</h2>`}})
customElements.define('k-h3', class extends TextHeader{ render(){return html`<h3>${super.render()}</h3>`}})
customElements.define('k-h4', class extends TextHeader{ render(){return html`<h4>${super.render()}</h4>`}})
customElements.define('k-h5', class extends TextHeader{ render(){return html`<h5>${super.render()}</h5>`}})
customElements.define('k-h6', class extends TextHeader{ render(){return html`<h6>${super.render()}</h6>`}})
